'use client';

import { c as _c } from "react/compiler-runtime";
import { useGetUser } from '@morfi/backend-sdk-v2/client';
import { useState } from 'react';
import { StreakCalendarSheet } from './streak-calendar-sheet';
import { StreakLevelsSheet } from './streak-levels-sheet';
import { StreakShareButton } from './streak-share-button';
import { StreakWidgetView } from './streak-widget-view';
import { StreaksHowItWorksDialog } from './streaks-how-it-works-dialog';
interface StreakWidgetProps {
  userId: string;
  walletPubkeys?: readonly string[];
}

/** Portfolio streak card — fetches the streak and renders the presentational view. */
export function StreakWidget(t0) {
  const $ = _c(30);
  const {
    userId,
    walletPubkeys
  } = t0;
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [levelsOpen, setLevelsOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  let t1;
  if ($[0] !== walletPubkeys) {
    t1 = walletPubkeys ?? [];
    $[0] = walletPubkeys;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["currentStreak", "longestStreak", "streakLastLocalDate"];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== userId) {
    t3 = {
      identifier: userId,
      walletPubkeys: t1,
      fields: t2
    };
    $[3] = t1;
    $[4] = userId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data
  } = useGetUser(t3);
  const currentStreak = data?.currentStreak ?? 0;
  const t4 = data?.longestStreak ?? 0;
  let t5;
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setCalendarOpen(true);
    t6 = () => setLevelsOpen(true);
    t7 = () => setHelpOpen(true);
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
  }
  let t8;
  if ($[9] !== currentStreak || $[10] !== userId) {
    t8 = <StreakShareButton userId={userId} currentStreak={currentStreak} />;
    $[9] = currentStreak;
    $[10] = userId;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== currentStreak || $[13] !== helpOpen || $[14] !== t4 || $[15] !== t8) {
    t9 = <StreakWidgetView currentStreak={currentStreak} longestStreak={t4} onViewCalendar={t5} onViewLevels={t6} onShowHelp={t7} helpOpen={helpOpen} browseHref="/markets" shareSlot={t8} />;
    $[12] = currentStreak;
    $[13] = helpOpen;
    $[14] = t4;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== calendarOpen || $[18] !== userId) {
    t10 = <StreakCalendarSheet userId={userId} open={calendarOpen} onOpenChange={setCalendarOpen} />;
    $[17] = calendarOpen;
    $[18] = userId;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== levelsOpen || $[21] !== userId) {
    t11 = <StreakLevelsSheet userId={userId} open={levelsOpen} onOpenChange={setLevelsOpen} />;
    $[20] = levelsOpen;
    $[21] = userId;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== helpOpen) {
    t12 = <StreaksHowItWorksDialog open={helpOpen} onOpenChange={setHelpOpen} />;
    $[23] = helpOpen;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t12 || $[28] !== t9) {
    t13 = <div className="flex h-full min-w-0 flex-col">{t9}{t10}{t11}{t12}</div>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
    $[28] = t9;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}